<template>
  <div>
    <div
      class="hero hero-cover hero-gradient"
      :style="{
        'background-image': `url('/img/suprasolar/suprasolar-cover.jpg')`,
      }"
    >
      <div class="container">
        <h1 class="text-white text-center">SupraSolar</h1>
      </div>
    </div>

    <div
      class="section push-content bg-white text-secondary text-justify"
      v-scroll-reveal
    >
      <div class="container">
        <figure class="mb-16">
          <img
            class="mx-auto max-w-xs"
            src="/img/suprasolar/suprasolar-black.svg"
            alt="SupraSolar logo"
          />
        </figure>

        <h2 class="text-2xl">
          Supra Solar fotonaponske solarne elektrane po modelu ključ u ruke
        </h2>

        <span class="block w-3/4 sm:w-32 h-px bg-gray-200 my-4 xl:my-8"></span>

        <p class="font-light">
          Dobivanje resursa iz ekološki prihvatljivih i obnovljivih izvora sve
          je aktualnije tema s obzirom da ljudi postaju svjesni važnosti brige i
          očuvanja planeta.
        </p>

        <p class="font-light">
          Fotonaponske solarne elektrane igraju ključnu ulogu u tranziciji prema
          održivijoj budućnosti uz obnovljive izvore energije. One nude pouzdano
          i ekološki prihvatljivo rješenje za potrebama rastuće globalne
          potražnje za energijom uz smanjenje emisije ugljičnog dioksida i borbu
          protiv klimatskih promjena.
        </p>

        <p class="font-light">
          Želite li koristiti ekološki prihvatljive izvore energije a ujedno i
          smanjiti troškove električne energije, fotonaponska solarna elektrana
          po principu ključ u ruke je brzo isplativa investicija koja nudio
          cjelogodišnju opskrbu električnom energijom. Naš tim stručnjaka će
          osmisliti strategiju za uspješno korištenje obnovljivih izvora
          energije, te vam ponuditi odgovarajuće energetsko rješenje.
        </p>
      </div>
    </div>

    <div class="section bg-gray-100" v-scroll-reveal>
      <div class="container _xl pull-content mb-8 md:mb-12 xl:mb-16 xxl:mb-24">
        <figure
          class="cover cover-image"
          :style="
            `background-image: url('/img/suprasolar/suprasolar-middle.jpg')`
          "
        ></figure>
      </div>

      <div class="container text-secondary text-justify">
        <h2 class="text-2xl">
          Projektiranje Supra Solar fotonaponskih solarnih elektrana po najvišim
          standardima i principu ključ u ruke
        </h2>
      </div>

      <div class="container _xl mt-16" v-if="items.length">
        <div class="flex flex-wrap">
          <div
            v-for="(item, i) in items"
            :key="`solar-item-${i}`"
            class="card _no-cursor cols p-10 bg-cover _overlay md:py-16 xl:pt-36 xl:pb-12"
            :class="[
              items.length % 2 !== 0 && i + 1 == items.length
                ? 'cols-full'
                : '',
            ]"
            :style="`background-image: url('${item.image}')`"
            v-scroll-reveal
          >
            <div class="card-body z-1">
              <h3 class="card-title">
                <span class="text-white">{{ item.name }}</span>
              </h3>
              <p
                class="leading-tight text-gray-300 italic my-4 xl:my-8"
                v-if="item.description"
                v-text="item.description"
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section bg-secondary">
      <div class="container _xl">
        <h3 class="text-4xl lg:text-5xl xxl:text-6xl mb-8 md:mb-16">
          Suradnje i partnerstva
        </h3>

        <div
          v-for="(partner, p) in partners"
          :key="`partner-${p}`"
          class="card bg-gray-900"
          v-scroll-reveal
        >
          <div class="card-body flex-col">
            <figure class="mb-8">
              <img :src="partner.image" :alt="partner.name" />
            </figure>

            <span
              class="text-white text-4xl italic"
              v-text="partner.name"
            ></span>

            <p class="font-light mt-2" v-text="partner.description"></p>
          </div>
        </div>
      </div>
    </div>

    <div class="projects-title section push-content bg-white text-secondary">
      <div class="container _xl" v-scroll-reveal>
        <h2 class="text-4xl lg:text-5xl xxl:text-6xl">Projekti</h2>
      </div>
    </div>
    <div class="projects section bg-white text-secondary">
      <div class="container _carousel pull-content">
        <carousel
          class="-ml-12 xl:ml-0 -mt-12"
          :nav="false"
          :dots="false"
          :responsive="carouselResponsive"
          @drag="dragIt"
          @dragged="draggedIt"
          v-scroll-reveal
        >
          <div
            v-for="(project, i) in projects"
            class="pl-12 xl:pr-12 xl:pl-0 pt-12"
            :key="`project-${i}`"
          >
            <figure
              tag="figure"
              class="carousel-image"
              :class="isDragging ? 'disable-link' : ''"
              :style="{
                backgroundImage: `url(${
                  project.card ? project.card : project.image
                })`,
              }"
            ></figure>

            <h3
              tag="h3"
              class="my-6"
              :class="isDragging ? 'disable-link' : ''"
              v-text="project.name"
            ></h3>

            <span class="block" v-text="project.services_list"></span>
            <span class="block" v-text="project.timeframe"></span>
          </div>
        </carousel>

        <router-link
          :to="{ name: 'projects' }"
          class="inline-block text-secondary hover:text-primary font-bold italic border-t-10 border-primary pt-4 mt-8 lg:mt-16"
          >Pogledaj sve projekte</router-link
        >
      </div>
    </div>

    <div class="section bg-gray-100 text-secondary">
        <div class="container _xl mb-8 md:mb-16">
            <h4 class="text-4xl lg:text-5xl xxl:text-6xl text-center">Kontaktirajte nas i zatražite ponudu!</h4>
        </div>

        <supra-solar-contact />
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import SupraSolarContact from '../partials/SupraSolarContact.vue';
import { SupraSolarProjects } from "../../config/suprasolar";

export default {
  components: {
    carousel,
    SupraSolarContact,
  },

  data() {
    return {
      items: [
        {
          image:
            "/img/suprasolar/suprasolar-projektiranje-i-strucno-savjetovanje.jpg",
          name: "Projektiranje i stručno savjetovanje",
          description:
            "U skladu s važećom zakonskom regulativom i propisima te domaćim (HRN) i međunarodnim (IEC) normama",
        },
        {
          image: "/img/suprasolar/suprasolar-posredovanje-i-savjetovanje.jpg",
          name: "Posredovanje i savjetovanje",
          description:
            "Posredovanje i savjetovanje s javnopravnim tijelim (HEP ODS)",
        },
        {
          image: "/img/suprasolar/suprasolar-financiranje.jpg",
          name: "Financiranje projekta",
          description:
            "Koristeći EU fondove i domaća sredstva namijenjena za poticanje izgradnje OIE te financiranje putem Leasing tvrtki",
        },
        {
          image: "/img/suprasolar/suprasolar-ispitivanje.jpg",
          name: "Ispitivanje",
          description: "Funkcijsko ispitivanje instalacije",
        },
        {
          image: "/img/suprasolar/suprasolar-kljuc-u-ruke.jpg",
          name: "Ključ u ruke",
          description:
            "Implementacija fotonaponske solarne elektrane po principu “Ključ u ruke” uz višegodišnju garanciju",
        },
        {
          image: "/img/suprasolar/suprasolar-odrzavanje.jpg",
          name: "Održavanje",
          description: "Održavanje i terenske usluge",
        },
      ],

      partners: [
        {
          image: "/img/suprasolar/suradnje/luxor.png",
          name: "Luxor solarni paneli",
          description:
            "Nadahnuti i motivirani velikom idejom solarne energije, u Luxoru od 2007. godine proizvode više od 28 različitih vrsta fotonaponskih modula po mjeri uz prisustvo u više od 85 zemalja diljem svijeta. Supra Net je od strane tvrtke Luxor certificirana za dostribuciju, instalaciju i servis fotonaponskih modula.",
        },
        {
          image: "/img/suprasolar/suradnje/sungrow.png",
          name: "Sungrow fotonaponski inverteri",
          description:
            "Sungrow Power Supply Co., Ltd. (“Sungrow”) je vodeći svjetski proizvođač fotonaposnih invertera sa više od 340 GW instaliranih invertera diljem svijeta. Sungrow je i lider u istraživanju i razvoju solarne energije uz široki portfelj proizvoda koji nudi PV inverterska rješenja i sustave za pohranu energije za komunalne, komercijalne i industrijske te stambene primjene, kao i međunarodno priznata rješenja za plutajuće fotonaponske elektrane, NEV pogonska rješenja, rješenja za punjenje električnih vozila i sustavi za proizvodnju obnovljivog vodika. Sa snažnim 26-godišnjim iskustvom u fotonaponskoj industriji, Sungrow je prisutan u više od 150 zemalja diljem svijeta.",
        },
        {
          image: "/img/suprasolar/suradnje/vivo-somnia.png",
          name: "Vivo Somnia d.o.o. – priprema i razvoj projekata",
          description:
            "Lokalni partner za projekte obnovljivih izvora energije, razvoj sunčanih elektrana, dizalica topline, solarnih kolektora, punionica električnih vozila te baterijskih sustava. Pružaju usluge u svim fazama razvoja sunčanih elektrana i drugih OIE. Točnije, usluge savjetovanja, analize stanja tržišta, vođenja projekata, analize isplativosti, projektiranja, ishođenja dozvola, te promocije i edukacije.",
        },
        {
          image: "/img/suprasolar/suradnje/rba-leasing.png",
          name: "Raiffeisen Leasing",
          description:
            "Financiranje projekta, nabave i ugradnje fotonaponskih elektrana korištenjem EU fondova i domaćih sredstva namijenjenih za poticanje izgradnje OIED.",
        },
      ],

      projects: SupraSolarProjects,

      carouselResponsive: {
        0: {
          items: 1,
          stagePadding: 0,
        },

        576: {
          items: 2,
          stagePadding: 100,
        },

        992: {
          items: 2,
          stagePadding: 140,
        },

        1440: {
          items: 2,
          stagePadding: 200,
        },
      },
      isDragging: false,
    };
  },

  mounted() {
    //
  },

  methods: {
    dragIt() {
      this.isDragging = true;
    },

    draggedIt() {
      this.isDragging = false;
    },
  },
};
</script>
